import Class from './c-content-chart-multiple-axes';
import './c-content-chart-multiple-axes@.vue';

export default Class;